import { getDataMapper, mapField } from "@/shared";

export const mapRepairStatusToServer = getDataMapper(
    {
        id: mapField("id", Number),
        title: mapField("title"),
        color: mapField("color"),
        text_color: mapField("textColor", () => "#000", { applyToNil: true }),
    },
    {
        shouldAvoidUndefined: true,
    }
);
